import {
    type AddCartItemArguments,
    addItemWithId,
    type CartWithAddedItem,
} from '@jsmdg/cart-library-ts';

async function addItemToCartAtUrl({
    productId,
    quantity,
    valueVoucherPrice,
}: AddCartItemArguments): Promise<CartWithAddedItem> {
    const result = await addItemWithId({
        productId,
        quantity,
        valueVoucherPrice,
    });
    // Broadcast the cart update to the other fragments on the page.
    const { BroadcastChannel } = await import('broadcast-channel');
    const syncCartBroadcastChannel = new BroadcastChannel('sync-cart-broadcast-channel', {
        webWorkerSupport: false,
    });

    // eslint-disable-next-line unicorn/require-post-message-target-origin
    await syncCartBroadcastChannel.postMessage({ cartVersion: result.cart.cartVersion });

    await syncCartBroadcastChannel.close();

    return result;
}

export { addItemToCartAtUrl };
